const reset = {
  name: 'findPwdReset',
  path: 'reset',
  component: resolve => require(['../../../../pages/custom/find-pwd/reset'], resolve)
}

export default reset
